import * as priceTable from 'src/api/pricetable'
import router from 'src/router'
import {
  GET_ALL_PRICE_TABLE,
  SET_PRICE_TABLE_HELPER,
  GET_PRICE_TABLE
} from 'src/store/mutation-types'

const getAllPriceTables = ({commit, dispatch, state}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  priceTable.getAllPriceTables(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_PRICE_TABLE, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_PRICE_TABLE, [])
    }
  })
}

const getAllPriceTableHelpers = ({commit}, params) => {
  priceTable.getAllHelpers(params).then(response => {
    commit(SET_PRICE_TABLE_HELPER, response)
  })
}

const getPriceTable = ({commit, dispatch}, configs) => {
  dispatch('toggleLoadding', true, {root: true})
  priceTable.getPriceTable(configs.id, configs.params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_PRICE_TABLE, response.data)
    } else if (response.code === 404) {
      dispatch('showNotify', {
        title: 'Không tìm thấy tài nguyên',
        type: 'warning'
      }, {root: true})
      dispatch('toggleLoadding', false, {root: true})
      router.push({name: 'price-table'})
    } else {
      dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setPriceTable = ({commit}, priceTable) => {
  commit(GET_PRICE_TABLE, priceTable)
}

export default{
  getAllPriceTables,
  getAllPriceTableHelpers,
  getPriceTable,
  setPriceTable
}



// WEBPACK FOOTER //
// ./src/components/pricetable/store/actions.js